import { render } from "./BMIIndex.vue?vue&type=template&id=7079ecca&scoped=true"
import script from "./BMIIndex.vue?vue&type=script&lang=js"
export * from "./BMIIndex.vue?vue&type=script&lang=js"

import "./BMIIndex.vue?vue&type=style&index=0&id=7079ecca&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7079ecca"]])

export default __exports__